// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "seatsLegendModalButton__button-fzENI";
export { _1 as "__esModule", _2 as "seatsLegendModalButton__button" }
export default { "__esModule": _1, "seatsLegendModalButton__button": _2 }
